import axios, { AxiosError } from 'axios';
import { DataCollection, NavigationData, PageData, SiteData } from './types';

const filterFlush = (path: string) => {
	if (path.indexOf('flush=') > 0) {
		const [base, query] = path.split('?');
		const params = new URLSearchParams(query);
		params.delete('flush');
		params.delete('urlspecialstoken');
		const filteredQuery = params.toString();
		return filteredQuery ? `${base}?${query}` : base;
	}
	return path;
};

export const getApiUrl = (path: string) => {
	return filterFlush(`/api${path}`.replace('//', '/'));
};

export async function fetchData<T extends object = Partial<DataCollection>>(path: string): Promise<T> {
	const apiUrl = getApiUrl(path);
	try {
		const res = await axios.get<T>(apiUrl, { withCredentials: true });
		return res.data as T;
	} catch (error: unknown) {
		if (error instanceof AxiosError) {
			if (error.response) {
				if (error.response.status === 404 || error.response.status === 500 || (error.response.data && error.response.data.id)) {
					return error.response.data;
				}
			}
		}
		throw new Error('There was an unexpected error');
	}
}

export const fetchNavigation = (href: string) => {
	return fetchData<NavigationData>(`/data/navigation/${href}`);
};

export const fetchSite = (href: string) => {
	return fetchData<SiteData>(`/data/site/${href}`);
};

export const fetchPage = (href: string) => {
	return fetchData<PageData>(`/data/url/${href}`);
};

export const fetchInitial = (href: string) => {
	return fetchData<DataCollection>(`/data/initial/${href}`);
};
